var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0 d-flex align-items-center justify-content-center",attrs:{"id":"landing-page","fluid":""}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('landing-nav'),_c('jumbo'),_c('gallery'),_c('info')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }